export default __webpack_public_path__ + "static/media/project-new-status.340bc87a.svg";